'use strict';

export default function f($http, utils) {
  'ngInject';

  return {

    getLocalCities(countryName) {
      return $http.get(utils.getApiUrl('intro/local_city/' + countryName));
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/modules/cities/seo_cities.service.js